import React from 'react';
import { Box, Chip, Divider, Stack, Typography, useTheme } from '@mui/material';
import {
  amlDatasetBadgeSx,
  amlFlaggedProfileSx,
  amlPepChipSx,
  getAmlFlaggedLabelSx,
  getAmlFlaggedNameSx,
  getAmlNationalityLabelSx,
} from './amlScreeningStyles';
import { getFlaggedName, formatMatchScore, getMatchScore, getPrimaryDataset, isPepMatch } from './amlScreeningHelpers';

export default function AmlFlaggedProfileCard({
  match,
  data = null,
  labels = {},
  showLabel = true,
  showType = false,
  showMatchScore = false,
  sx = {},
  children = null,
}) {
  const theme = useTheme();
  const datasetLabel = getPrimaryDataset(data, match);

  return (
    <Box sx={{ ...amlFlaggedProfileSx, ...sx }}>
      {showLabel && (
        <Typography sx={getAmlFlaggedLabelSx(theme)}>{labels.flaggedProfile ?? 'Flagged Profile'}</Typography>
      )}

      <Typography sx={getAmlFlaggedNameSx(theme)}>{getFlaggedName(match)}</Typography>

      {datasetLabel && (
        <Box component="span" sx={{ ...amlDatasetBadgeSx, mb: 2, display: 'inline-block' }}>
          {datasetLabel}
        </Box>
      )}

      <Divider sx={{ my: 2 }} />

      {showMatchScore && getMatchScore(match) != null && (
        <Typography variant="body2" sx={{ color: theme.palette.text.primary, mb: 1.5 }}>
          <Typography component="span" sx={getAmlNationalityLabelSx(theme)}>
            {labels.matchScore ?? 'Match Score'}:{' '}
          </Typography>
          {formatMatchScore(getMatchScore(match))}
        </Typography>
      )}

      {showType && match?.type && (
        <Typography variant="body2" sx={{ color: theme.palette.text.primary, mb: 1.5 }}>
          <Typography component="span" sx={getAmlNationalityLabelSx(theme)}>
            {labels.type ?? 'Type'}:{' '}
          </Typography>
          {match.type}
        </Typography>
      )}

      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={1.5}
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        justifyContent="space-between"
      >
        <Typography variant="body2" sx={{ color: theme.palette.text.primary }}>
          <Typography component="span" sx={getAmlNationalityLabelSx(theme)}>
            {labels.nationality ?? 'Nationality'}:{' '}
          </Typography>
          {match?.nationality ?? '—'}
        </Typography>

        <Chip
          label={
            isPepMatch(match)
              ? (labels.isPep ?? 'Politically Exposed Person (PEP)')
              : (labels.notPep ?? 'Not a Politically Exposed Person (PEP)')
          }
          size="small"
          variant="outlined"
          sx={amlPepChipSx}
        />
      </Stack>

      {children}
    </Box>
  );
}
